export default __webpack_public_path__ + "static/media/logo.0fe0ddb5.png";